module.exports = __webpack_public_path__ + "static/media/hangman_4.c8f3fce3.svg";